
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/png-converter",
      function () {
        return require("private-next-pages/png-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/png-converter"])
      });
    }
  